import React from 'react';

const StatCard = ({ title, value, subtitle, icon, trend, color = 'var(--primary)', onClick }) => {
  const cardStyle = {
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: '12px',
    padding: '20px',
    transition: 'all 0.3s ease',
    cursor: onClick ? 'pointer' : 'default'
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '16px'
  };

  const titleStyle = {
    fontSize: '12px',
    fontWeight: '600',
    color: 'var(--text-secondary)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  };

  const iconWrapperStyle = {
    width: '40px',
    height: '40px',
    borderRadius: '10px',
    background: `${color}20`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px'
  };

  const valueStyle = {
    fontSize: '32px',
    fontWeight: '700',
    color: 'var(--text-primary)',
    marginBottom: '8px'
  };

  const footerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px'
  };

  const trendStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontWeight: '600',
    color: trend?.type === 'up' ? '#10b981' : trend?.type === 'down' ? '#ef4444' : 'var(--text-secondary)'
  };

  const subtitleStyle = {
    color: 'var(--text-secondary)'
  };

  return (
    <div
      style={cardStyle}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div style={headerStyle}>
        <div style={titleStyle}>{title}</div>
        {icon && <div style={iconWrapperStyle}>{icon}</div>}
      </div>
      <div style={valueStyle}>{value}</div>
      <div style={footerStyle}>
        {trend && (
          <div style={trendStyle}>
            <span>{trend.type === 'up' ? '↑' : trend.type === 'down' ? '↓' : '→'}</span>
            <span>{trend.value}</span>
          </div>
        )}
        {subtitle && <div style={subtitleStyle}>{subtitle}</div>}
      </div>
    </div>
  );
};

export default StatCard;